import React, { Component } from 'react';
import DataTables from './DataTables';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import Menu from './Menu';
import Header from './Header';
import Footer from './Footer';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import * as XLSX from 'xlsx';
import { Navigate } from 'react-router-dom';
import { NC_DATE_GRID } from '../Utilities/AppData/NCDateGrid';
import { FORMAT_DATE } from '../Utilities/AppData/FormatDate';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LZString from 'lz-string';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';

class Nonconformities extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);

    const store = this.props.location.state;
    let stores = JSON.parse(localStorage.getItem('storeData'));
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];

    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];

    this.state = {
      title: 'Non Conformities',
      data: [],
      //storeValue: stores[0].storeId,
      storeValue: '',
      stores,
      wareHouses,
      modalOpen: false,
      visible: true,
      tableVisible: false,
      month: month,
      day: day,
      year,
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      message: '',
      proxyjson: [],
      loading: false,
      user: menu,
      pageAllowed: false,
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleFromDate = (e) => {
    this.setState(
      {
        FromDate: e.target.value,
      },
      function () {}
    );
  };

  handleToDate = (e) => {
    this.setState(
      {
        ToDate: e.target.value,
      },
      function () {}
    );
  };

  handleStoreValue = (e) => {
    this.setState(
      {
        storeValue: e.target.value,
      },
      function () {}
    );
  };

  handleSelect(fromDate = this.state.FromDate, toDate = this.state.ToDate) {
    this.setState({
      loading: true,
    });
    NC_DATE_GRID(
      '/fetchNonConfirmityDetailsByStore',
      FORMAT_DATE(this.state.FromDate),
      FORMAT_DATE(toDate),
      this.state.storeValue
    )
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        this.setState(
          {
            proxyjson: response,
            data: response.excelData,
            loading: false,
            tableVisible: true,
            visible: true,
          }
          // () => alert(JSON.stringify(response.excelData))
        );
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  }

  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? !val.featureAccess
          ? val.featureName == 'Non Conformities'
            ? (pageAllow = true)
            : ''
          : ''
        : ''
    );

    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
      });
      setTimeout(() => {
        this.setState({
          loading: false,
        });
      }, 1000);
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }

    //this.handleSelect();
  }

  render() {
    const {
      loading,

      modalOpen,
      message,
      tabIndex,
      pageAllowed,
    } = this.state;

    const exportToExcel = (data, title) => {
      const wb = XLSX.utils.book_new();
      const wsData = [
        [
          'Description', 'NC Status', 'NC DueDate', 'NC Created Date',
          'NC Created By', 'NC Assigned To', 'NC Source'
        ],
        ...data.map(item => [
          item.description, item.ncStatus, item.ncDueDate, item.ncCreatedDate,
          item.ncCreatedBy, item.ncAssignedTo, item.ncSource
        ])
      ];
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      XLSX.utils.book_append_sheet(wb, ws, title);
      XLSX.writeFile(wb, `${title}.xlsx`);
    };
    
    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? !val.featureAccess
              ? val.featureName == 'Non Conformities'
                ? (pageAllow = true)
                : ''
              : ''
            : ''
        )}
        {pageAllow === false ? (
      
          <Navigate to="/pageNotAllowed" state={{ id:'Non Conformities' }} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={this.state.message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={this.state.title} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <div className='row' style={{ marginBottom: '-30px' }}>
                  <div className='col-md-3 col-lg-3 col-sm-3'>
                    <ToastContainer
                      position='top-right'
                      autoClose={2000}
                      hideProgressBar={false}
                      newestOnTop={false}
                      closeOnClick
                      className=''
                      rtl={false}
                      pauseOnFocusLoss
                      draggable
                      pauseOnHover
                    />
                    <form style={{ background: 'none', padding: '0% 0%' }}>
                      <div className='form-group'>
                        <select
                          className='form-control'
                          value={this.state.storeValue}
                          onChange={this.handleStoreValue}
                        >
                          <option>Select a Store</option>
                          {this.state.stores
                            .sort((a, b) =>
                              a.storeName > b.storeName ? 1 : -1
                            )
                            .map((val, index) => (
                              <option key={val.storeId} value={val.storeId}>
                                {val.storeName}
                              </option>
                            ))}
                          {this.state.wareHouses
                            .sort((a, b) =>
                              a.storeName > b.storeName ? 1 : -1
                            )
                            .map((val, index) => (
                              <option key={val.storeId} value={val.storeId}>
                                {val.storeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </form>
                  </div>
                  {this.state.visible ? (
                    <form
                      className='form'
                      style={{ background: 'none', padding: '0% 0%' }}
                    >
                      <div
                        className='col-md-3  col-lg-3 col-sm-3'
                        style={{ marginTop: '0px' }}
                      >
                        <div className='form-group'>
                          <input
                            value={this.state.FromDate}
                            onChange={this.handleFromDate}
                            type='date'
                            style={{ borderRadius: '7px' }}
                            className='form-control'
                            data-inputmask="'alias': 'dd/mm/yyyy'"
                            data-mask=''
                          />
                        </div>
                      </div>
                      <div
                        className='col-md-3 col-lg-3 col-sm-3'
                        style={{ marginTop: '0px' }}
                      >
                        <div className='form-group'>
                          <input
                            value={this.state.ToDate}
                            onChange={this.handleToDate}
                            type='date'
                            style={{ borderRadius: '7px' }}
                            className='form-control'
                            data-inputmask="'alias': 'dd/mm/yyyy'"
                            data-mask=''
                          />
                        </div>
                      </div>
                      <div
                        className='col-md-3 col-lg-3 col-sm-3'
                        style={{ marginTop: '0px' }}
                      >
                        <button
                          type='button'
                          onClick={this.handleSelect}
                          className='btn btn-secondary deca-btn-yellow'
                        >
                          SUBMIT
                        </button>
                      </div>
                    </form>
                  ) : null}
                </div>
                <br /> <br />
                {this.state.tableVisible ? (
                  <div>
                    {this.state.data.length > 0 ? (
                      <button
                        className='btn btn-secondary deca-btn-yellow'
                        onClick={() => exportToExcel(this.state.data, this.state.title)}
                      >
                        Export to Excel
                      </button>
                    ) : (
                      ''
                    )}

                    <div className='DataGridMain gridbgWhite'>
                      <div style={{ margin: '10px' }}>
                        <DataTables
                          title='DataGrid'
                          count={true}
                          storeDashboard={true}
                          data={this.state.proxyjson}
                          name='IncidentsDateGrid'
                        />
                      </div>
                    </div>
                  </div>
                ) : null}
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default Nonconformities;
